"use client";
  import { MenuIcon } from "lucide-react";
import { useState } from "react";
import { DashboardNav } from "./dashboard-nav";
import { navItems } from "../../data/constants";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";

 
interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
 }

export function MobileSidebar({ className }: SidebarProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <MenuIcon />
        </SheetTrigger>
        <SheetContent side="left" className="!px-0">
          <div className="py-4 space-y-4">
            <div className="px-3 py-2">
              <h2 className="px-4 mb-2 text-lg font-semibold tracking-tight">
                Menu
              </h2>
              <div className="space-y-1">
                <DashboardNav items={navItems} setOpen={setOpen} />
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
